<template>
  <div class ="login">
    <div class = "left-pic">
      <div style="width:100%;height: 20%;">
      <img style="display: block;width: 20%;margin-top:5%;margin-left:5%" src = "../assets/logomks.png" />
      </div>
      <div style="width:100%;height:80%;">
        <!-- <div style="display:inline-block;width: 40%;height:100%;vertical-align: top;padding-top: 200px;-webkit-box-reflect:below 0 -webkit-linear-gradient(transparent,transparent 20%,rgba(255,255,255,.3));"> -->
          <div style="display:inline-block;width: 40%;height:100%;vertical-align: top;padding-top: 200px;">
          <div style="font-size:60px;color:#0049c8;weight:bold;">{{ $t('login.MS_ENERGY') }}</div>
          <div style="font-size:60px">{{ $t('login.Battery_Matrix') }}</div>

          </div>
        <div style="display:inline-block;width: 40%;">
          <img style="width: 90%;margin-top: 20%" src = "../assets/earth.png" />
       </div>
    </div>
        <!-- <img src = "../assets/mks.png" /> -->
    </div>
    <LoginView :showLabel="tag" :selectedLanguage="selectedLanguage" @change="showChange($event)" />
    <ForgetView :showLabel="tag" :selectedLanguage="selectedLanguage" @change="showChange($event)" />
    <RegisterView :showLabel="tag" :selectedLanguage="selectedLanguage" @change="showChange($event)" />
    <!-- <div class = "login-main">
      <div>
        <span class = "title" style="font-size:30px">美克生诊断计算平台</span>
      </div>
          <el-input v-model="username" placeholder="请输入账户" style = "font-size:18px;height:40px;margin-top:20px;"></el-input>
          <el-input placeholder="请输入密码" v-model="password" show-password style = "margin-top:15px;font-size:18px;"></el-input>
          <div style = "margin-top:15px;display:flex">
            <span class = "forget-password" style="font-family: '楷体','楷体_GB2312';font-size:18px;color:#0049c8;margin-right:auto;margin-left:10px">忘记密码？</span>
            <span class = "register" style="font-family: '楷体','楷体_GB2312';font-size:18px;color:#0049c8;margin-right:10px;margin-left:auto">免费注册</span>
          </div>
       <div>
          <div style = "margin-top:30px;display:flex">
            <span class="u-checkbox tabfocus u-checkbox-select">                                           
                <input id="un-login" type="checkbox" name="un-login" class="un-login" v-model="isAgree">
            </span>
            <span class = "confirm" style="font-family: '楷体','楷体_GB2312';font-size:15px;">我已阅读并同意</span>
            <span class = "user-agreement" style="font-family: '楷体';font-size:15px;font-weight: bolder;text-decoration: underline;">用户协议</span>
            <span class = "confirm" style="font-family: '楷体','楷体_GB2312';font-size:15px;">和</span>
            <span class = "user-agreement" style="font-family: '楷体';font-size:15px;font-weight: bolder;text-decoration: underline;">隐私政策</span>
          </div>
       </div>
       <el-button style = "margin-top:30px;background:#0049c8;color:#ffffff;width:80%" @click="handleSubmit">登录</el-button>
    </div> -->
    <LanguageSelect @language-change="handleLanguageChange" v-model="selectedLanguage" style="height:30%;margin-right:30px;margin-left:0px" />
  </div>
</template>

<script>
import LanguageSelect from './LanguageSelect.vue'
import LoginView from './LoginRegister/Login.vue'
import ForgetView from './LoginRegister/Forget.vue'
import RegisterView from './LoginRegister/Register.vue'
// import { list } from '../../mock/index'
export default {
  name: 'LoginMain',
  components:{
    LanguageSelect,
    LoginView,
    ForgetView,
    RegisterView
  },
  props: {
    msg: String,
  },
  data(){
    return{
      tag:1,
      selectedLanguage:'en',
    };
  },
  methods:{
    showChange(i){
      this.tag=i;
    },
    handleLanguageChange(language) {
      this.selectedLanguage = language; // Update the selected language
    },
  },
  mounted() {
    // list().then(res => {
    //     console.log(res)
    //   })
  }
}
</script>

<style  lang="less" type="text/less">

.login{
  display:flex;
  .left-pic{
    display:inline block;
    width: 60%;
    height:100%;
  }
}
</style>




